/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Redirection after login BEGIN
   const loginBtn = document.querySelector('.not-logged .btn');
   const redirectAfterLoginKey =  "redirectAfterLogin";

   if (loginBtn) {
    loginBtn.addEventListener('click', (e) => {
      //set current url in local storage
      localStorage.setItem(redirectAfterLoginKey, window.location.href);
    });
   }

   const redirectAfterLogin = () => {
    const userId = document.getElementById('userId')?.innerHTML;

    const currentUrl = localStorage.getItem(redirectAfterLoginKey);
    if (currentUrl && !window.location.href.includes("/login")) {
      localStorage.removeItem(redirectAfterLoginKey);
      if (userId) {
          window.location.href = currentUrl;
      }
    } else if (window.location.href.includes("/transition")) {
        window.location.href = "/account";
    }
   }

   redirectAfterLogin();
  // Redirection after login END

  const focusOnTheEmenet = (event, elementSelector) => {
    event.preventDefault();

    const elementToFocus = document.querySelector(elementSelector);
    if (!elementToFocus) return;
    elementToFocus.focus();
  };

  const onClickElementFocusElement = (buttonSelector, elementFocusSelector) => {
    const elementToClick = document.querySelector(buttonSelector);

    elementToClick &&
      elementToClick.addEventListener("click", (e) => {
        e.preventDefault();
        focusOnTheEmenet(e, elementFocusSelector);
      });
  };

  const toggleVariantImages = () => {
    /*   
    in value - selected variant, same value is it the all imagese's alt text, from the shopify admin
    <input type="hidden" name="id" value="{{ current_variant.id }}" form="{{ product_form_id }}">
  */
    const selectedVariantHiddenInput = document.querySelector(
      "#TemplateProduct input[name='id']"
    );
    const productSlidesArr = Array(
      ...document.querySelectorAll(".product__slide")
    );
    const putLastImageInTheEnd = () => {
      const imageToPutInTheEnd = document.querySelector(
        ".product__slide:has(.product__photo[data-image-alt='last'])"
      );
      if (!imageToPutInTheEnd) return;
      imageToPutInTheEnd.parentNode.appendChild(imageToPutInTheEnd);
    };
    // images with ALt text: "last" is also included
    const selectedVariantSlidesArr = Array(
      ...document.querySelectorAll(
        `.product__slide:has([alt="${selectedVariantHiddenInput.value}"])`
      ),
      ...document.querySelectorAll(`.product__slide:has([alt=""])`),
      ...document.querySelectorAll(`.product__slide:has([alt="last"])`)
    );

    // all images hidden
    toHideArrayNodes(productSlidesArr, true);
    // show with images with correct alt
    toHideArrayNodes(selectedVariantSlidesArr, false);
    // remove input onchange event listener
    selectedVariantHiddenInput.removeEventListener(
      "change",
      toggleVariantImages
    );
    // add input onchange event listener
    selectedVariantHiddenInput.addEventListener("change", toggleVariantImages);

    putLastImageInTheEnd();
  };

  const toHideArrayNodes = (array, toHide) => {
    array.map((el) => {
      if (toHide) {
        el.classList.add("hidden");
      } else {
        el.classList.remove("hidden");
      }
    });
  };

  const productSection = document.querySelector(
    '#TemplateProduct[data-variant-image="true"]'
  );

  if (productSection) {
    toggleVariantImages();
  }
  // #endregion product page; Variant images in the admin / data-variant-images="true" in the product.liquid

  onClickElementFocusElement(
    ".cards-with-icon .card a[href='/form']",
    "input.contactFormText"
  );

  // #region header hide/show
  // hide/show on scroll. add data-scrolling-bottom OR data-scrolling-top to header for animation
  var lastScrollTop = 0;
  let ticking = false;
  const header = document.querySelector(".theme__header");
  window.addEventListener(
    "scroll",
    function (e) {
      var st = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (st > lastScrollTop) {
            header.setAttribute("data-scrolling-bottom", "");
            header.removeAttribute("data-scrolling-top");
          } else if (st < lastScrollTop) {
            header.setAttribute("data-scrolling-top", "");
            header.removeAttribute("data-scrolling-bottom");
          }
          lastScrollTop = st <= 0 ? 0 : st;
          ticking = false;
        });

        ticking = true;
      }
    },
    false
  );
  // #endregion header hide/show

  // #region made footer newsletter behaviour like on the WP site
  // works in pair with components/_form-elements.scss
  function formSuccesHandler() {
    if (!document.querySelector(".has-success .input-group__field")) return;
    // to paint input
    const formInput = document.querySelector(
      ".has-success .input-group__field"
    );
    formInput.classList.add("success");
    // TODO: to scroll instantly
    // to clear succes element & colors
    setTimeout(() => {
      document
        .querySelector(".newsletter-form")
        .classList.remove("has-success");
      document.documentElement.style.scrollBehavior = "smooth";
      document.documentElement.style.setProperty("--scroll-behavior", "smooth");
    }, 5000);
  }
  // #endregion made footer newsletter behaviour like on WP site

  function onDOMContentLoaded(e) {
    formSuccesHandler();
  }
  document.addEventListener("DOMContentLoaded", (e) => onDOMContentLoaded(e));

  //Buy now form functionality (interventions cards, bundle cards)
  const buyNowForms = document.querySelectorAll(".buy-now-form");

  buyNowForms.forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const form = this;

      // Create an XMLHttpRequest object
      const xhr = new XMLHttpRequest();
      xhr.open("POST", form.action, true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

      // Create a callback to handle the response
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          window.location.href = "/checkout";
        }
      };

      // Serialize the form data
      const formData = new FormData(form);
      const data = new URLSearchParams(formData).toString();

      // Send the request
      xhr.send(data);
    });
  });

  // Switch bundles plans term functionality
  const switchers = document.querySelectorAll(".bundles-list__switcher");

  switchers.forEach((switcher) => {
    const buttons = switcher.querySelectorAll("button");

    const contentWrapper = switcher.nextElementSibling;
    const plans = contentWrapper.querySelectorAll(".bundles-list__set");
    buttons.forEach((button) => {
      button.addEventListener("click", function () {
        const target = this.dataset.target;
        buttons.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");
        plans.forEach((plan) => {
          plan.classList.remove("active");
          if (plan.classList.contains(target)) {
            plan.classList.add("active");
          }
        });
      });
    });
  });

  //#region - redirect to checkout_url
  const urlParams = new URLSearchParams(window.location.search);

  //get checkout_url search param from url, set it in the local storage as url with current domain and remove it from the url
  const checkoutUrl = urlParams.get("checkout_url");

  if (checkoutUrl) {
    const checkoutPageUrl = new URL(window.location.origin + checkoutUrl);

    const currentUrl = new URL(window.location.href);
    localStorage.setItem("checkoutUrl", checkoutPageUrl);
    currentUrl.searchParams.delete("checkout_url");
    window.history.pushState({}, "", currentUrl);
  }

  //if login page, click on login button when it appears
  /* 
  case after && if user logged in with SSO, than logged out only from shopify account.
  than from the web app clicks "Manage membership".
  https://ch.xlongevity.com/tools/recurring/login?redirect=customer_portal%2Foverview
  */
  if (window.location.pathname.includes("/login") && !window.location.pathname.includes("/recurring")) {
    const { remove } = addPreloader();
    const loginForm = document.querySelector("#customer_login");

    const observer = new MutationObserver((_, observer) => {
      const loginButton = document.querySelector("#customer_login .btn");

      if (loginButton) {
        observer.disconnect();
        if (localStorage.getItem("isUserLoggingOut")) {
          remove()
          // if isUserLoggingOut is true -> redirect to the home page & cleen localStorage
          localStorage.clear("isUserLoggingOut")
          // window.location.href = window.location.href.replace(/\/account.*/, "");
        }
        else { loginButton?.click() };
      }
    });

    observer.observe(loginForm, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  // .../account page
  const shopAccountPage = /\/account$/;
  if (shopAccountPage.test(window.location.href)) {
    const logoutBtn = document.querySelector('[href="/account/logout"]');

    const handleLogoutClick = (event) => {
      if (event.target.matches('[href="/account/logout"]')) {
        localStorage.setItem("isUserLoggingOut", true)
      }
    }
    logoutBtn.addEventListener('click', handleLogoutClick);
  }


  function redirectOnCheckout() {
    const checkoutUrl = localStorage.getItem("checkoutUrl");

    if (checkoutUrl && !window.location.href.includes("/login")) {
      const id = document.getElementById("userId")?.innerHTML;
      localStorage.removeItem("checkoutUrl");
      if (id) {
        window.location.href = checkoutUrl;
      }
    }
  }

  //get centerCode search param from url and put it in the local storage
  const centerCode = urlParams.get("centerCode");

  if (centerCode) {
    localStorage.setItem("centerCode", centerCode);
  }

  //get centerCode from local storage and check is user logged in
  const centerCodeFromLocalStorage = localStorage.getItem("centerCode");
  const email = document.getElementById("userEmail")?.innerHTML;
  const id = document.getElementById("userId")?.innerHTML;
  const appUrl = document.getElementById("appEndpoint")?.innerHTML;

  const removeCenterCode = () => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete("centerCode");
    window.history.pushState({}, "", currentUrl);
    localStorage.removeItem("centerCode");
  };

  if (centerCodeFromLocalStorage && email && id && appUrl) {
    const payload = {
      id,
      centerCode: centerCodeFromLocalStorage,
      email,
    };

    const { remove } = addPreloader();

    fetch(`${appUrl}/update-shopify-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success:", data);
      })
      .catch((error) => {
        console.log("Error:", error);
      })
      .finally(() => {
        removeCenterCode();
        redirectOnCheckout();
        remove();
      });
  } else {
    redirectOnCheckout();
  }

  function addPreloader() {
    const preloader = document.createElement("div");
    preloader.classList.add("preloader");
    document.body.appendChild(preloader);

    return {
      remove: () => {
       const preloaders  = document.querySelectorAll('.preloader');
       preloaders.forEach(preloader => preloader.remove());
      },
    };
  }

  //#endregion - redirect to checkout_url

  // #region "Buy it now" text - single product page
// This function will attempt to find the button and change its text
const changeBuyNowText = () => {console.log("interval external");

  if (!document.querySelector('.product__submit__item[data-buy-it-now-text]')) return;
  if (document.querySelector('.product__submit__item[data-buy-it-now-text]').dataset.buyItNowText !== "") {
    function changeButtonTextBuyItNow() {
      console.log("interval internal");
      try {
        // Get the button with text "Buy it now"
        const button = document.querySelector(
          '.shopify-payment-button__button.shopify-payment-button__button--unbranded:not(.shopify-payment-button__button--hidden)'
        );

        // Change the text of the button
        const newText = document.querySelector('.product__submit__item[data-buy-it-now-text]').dataset.buyItNowText;
        button.textContent = newText;
        // Stop the interval from running
        clearInterval(interval);

      } catch (err) {
        console.log(err, "Buy it now button is loading...");
      }
    }
    // Run the function every 200 milliseconds until the button is found and updated
    const interval = setInterval(changeButtonTextBuyItNow, 10);
  }
}
changeBuyNowText()
// #endregion "Buy it now" text - single product page

  console.log("custom js, last line has been reached");

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
